import React from 'react';
import { Section } from './Section';
import { Mic, Cpu, Zap, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  icon: Mic,
  title: 'Listens continuously',
  desc: 'The Pod device captures ambient audio in your space 24/7 — without recording or storing anything.'
}, {
  icon: Cpu,
  title: 'Detects threats locally',
  desc: 'An on-device neural network analyzes audio in real time. It recognizes fights, gunshots, screams, and custom keywords without training.'
}, {
  icon: Zap,
  title: 'Triggers alert instantly',
  desc: 'The moment a threat is detected, it sends an alert — including the triggering audio fragment — to your alarm center.'
}, {
  icon: ShieldCheck,
  title: 'Alarm center responds',
  desc: 'Alerts are routed via CloudSurgard, compatible with all alarm monitoring centers. No integration required.'
}];
export function HowItWorks() {
  return <Section id="how-it-works" className="bg-white" data-id="element-90">
      <div className="text-center mb-20" data-id="element-91">
        <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-92">
          How it works
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-zinc-900" data-id="element-93">
          From sound to alert in seconds.
        </h2>
      </div>

      <div className="relative" data-id="element-94">
        <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-[2px] bg-zinc-200" data-id="element-95">
          <motion.div className="h-full bg-peoplecall" initial={{
          width: '0%'
        }} whileInView={{
          width: '100%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-96" />
        </div>

        <div className="grid lg:grid-cols-4 gap-8 relative z-10" data-id="element-97">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-98">
              <div className="w-24 h-24 rounded-full bg-white border-2 border-zinc-200 flex items-center justify-center mb-6 relative z-10 group hover:border-peoplecall transition-colors duration-300 shadow-sm" data-id="element-99">
                <step.icon className="w-10 h-10 text-zinc-500 group-hover:text-peoplecall transition-colors duration-300" data-id="element-100" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-peoplecall text-white font-bold flex items-center justify-center text-sm shadow-md" data-id="element-101">
                  {index + 1}
                </div>
              </div>

              <h3 className="text-xl font-bold text-zinc-900 mb-3" data-id="element-102">
                {step.title}
              </h3>
              <p className="text-zinc-600 text-sm leading-relaxed" data-id="element-103">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}